import { render, staticRenderFns } from "./operation-board-notice.vue?vue&type=template&id=6b1ea9c4&scoped=true&"
import script from "./operation-board-notice.vue?vue&type=script&lang=js&"
export * from "./operation-board-notice.vue?vue&type=script&lang=js&"
import style0 from "./operation-board-notice.vue?vue&type=style&index=0&id=6b1ea9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ea9c4",
  null
  
)

export default component.exports